<template>
  <div class="checkout-payment-box-wrapper">
    <slot name="title"/>
    <div class="checkout-payment-box-inner">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'checkout-payment-box'
}
</script>

<style lang="scss" scoped>
.checkout-payment-box-wrapper {
  &:first-child {
    margin-bottom: .1rem;
  }
}

.checkout-payment-box-inner {
  padding: 3.2rem 1.6rem .2rem;
  background: $white;

  @media (map_get($breakpoints, sm)) {
    padding: 3.2rem 4rem .2rem;
  }
}
</style>
